export default {
  "": "",
  "24hChange": "Perubahan 24J",
  "24hTurnover": "Perputaran 24 Jam",
  "action": "Tindakan",
  "AddLoan": "Tambah",
  "AdjustLoanFail": "Gagal menyesuaikan jumlah jaminan. Harap mencoba lagi nanti. ",
  "all": "Semua",
  "apply": "Terapkan",
  "assets": "Koin",
  "available": "Tersedia",
  "balance": "Saldo Tersedia",
  "bi_all": "Semua",
  "bi_average_change": "Perubahan Rata-Rata 24 Jam",
  "bi_down_amount": "Volume Loser",
  "bi_down_num": "Loser",
  "bi_eth_gas": "Gas ETH",
  "bi_google_tips": "Angka mewakili minat pencarian untuk satu istilah di Google relatif terhadap poin tertinggi di tabel untuk wilayah dan waktu tertentu. Nilai 100 adalah puncak popularitas istilah tersebut.",
  "bi_google_trends": "BTC di Google Trends",
  "bi_market_cap": "Market Cap Mata Uang Kripto Global (USDT)",
  "bi_market_distribution": "Distribusi Market Cap",
  "bi_market_sentiment": "Sentimen Pasar",
  "bi_market_trends": "Tren Pasar Mata Uang Kripto",
  "bi_market_volatility": "Volatilitas Pasar Mata Uang Kripto",
  "bi_normal_amount": "Koin yang Tidak Mengalami Perubahan Volume",
  "bi_normal_num": "Tanpa Perubahan",
  "bi_page_title": "Tren Pasar Kripto, Pelacak Sentimen & Volatilitas {'|'} Bybit",
  "bi_price_distribution": "Distribusi Perubahan Harga",
  "bi_ranking": "Peringkat",
  "bi_ranking_sector": "Sektor",
  "bi_ranking_tips": "Saat ini, hanya 3 asetteratas menurut kapitalisasi pasar sektor ini yang akan ditampilkan.",
  "bi_sentiment1": "Ketakutan Ekstrem",
  "bi_sentiment2": "Ketakutan",
  "bi_sentiment3": "Netral",
  "bi_sentiment4": "Keserakahan",
  "bi_sentiment5": "Keserakahan Ekstrem",
  "bi_social": "Trending di Media Sosial",
  "bi_td_trade": "Trade",
  "bi_th_action": "Aksi",
  "bi_th_change": "Perubahan 24 Jam",
  "bi_th_currency": "Mata Uang",
  "bi_th_market": "Kapitalisasi Pasar",
  "bi_th_price": "Harga",
  "bi_th_sector": "Sektor",
  "bi_th_up_down": "Jumlah Gainer/Loser",
  "bi_th_volume": "Volume Perdagangan 24 Jam",
  "bi_top_20": "Kapitalisasi Pasar",
  "bi_top_gain": "Top Gainer (% Perolehan)",
  "bi_total_market": "Total Kapitalisasi Pasar",
  "bi_trading_distribution": "Distribusi Volume Perdagangan",
  "bi_trading_vol": "Volume Perdagangan Mata Uang Kripto Global 24J (USDT)",
  "bi_twitter_explore": "Jelajah Twitter",
  "bi_twitter_tips1": "Topik Hangat yang Muncul di Twitter",
  "bi_twitter_tips2": "Topik yang sedang Trending di Twitter",
  "bi_twitter_topics": "Topik Trending Twitter",
  "bi_up_amount": "Volume Gainer",
  "bi_up_num": "Gainer",
  "bi_view": "Lihat",
  "bi_volume_distribution": "Distribusi Perubahan Volume",
  "botValidateErrCode101": "Harga minimum terlalu rendah",
  "botValidateErrCode102": "Harga minimum terlalu tinggi",
  "botValidateErrCode103": "Harga maksimum terlalu rendah",
  "botValidateErrCode104": "Harga maksimum terlalu tinggi",
  "botValidateErrCode105": "Grid terlalu sedikit",
  "botValidateErrCode106": "Grid terlalu banyak",
  "botValidateErrCode107": "Jumlah investasi terlalu rendah dan tidak memenuhi persyaratan investasi",
  "botValidateErrCode108": "Jumlah investasi terlalu tinggi dan melebihi batas investasi kontrak",
  "botValidateErrCode109": "Harga ambil untung terlalu rendah",
  "botValidateErrCode110": "Harga ambil untung terlalu tinggi",
  "botValidateErrCode111": "Harga stop rugi terlalu rendah",
  "botValidateErrCode112": "Harga stop rugi terlalu tinggi",
  "botValidateErrCode113": "Harga entri terlalu rendah",
  "botValidateErrCode114": "Harga entri terlalu tinggi",
  "cancel": "Tidak",
  "cancelAll": "Batalkan Semua",
  "cancelOrder": "Batalkan",
  "chart": "Grafik",
  "close": "Tutup",
  "confirm": "Ya",
  "contest-about-to-start": "Segera Hadir",
  "contest-accumulate-volume": "Volume Transaksi Kumulatif",
  "contest-accumulate-volume-start": "Pendaftaran berhasil! Volume Perdagangan Spot Anda akan dihitung.",
  "contest-achieve-standards": "Memenuhi Syarat",
  "contest-activity-rules": "Peraturan Acara",
  "contest-activity-rules-title": "Aturan Aktivitas",
  "contest-activity-time": "Periode Acara",
  "contest-countdown": "Hingga Kontes Berakhir",
  "contest-countdown-day": "HARI,",
  "contest-cumulative-volume": "Volume Perdagangan Total ({unit})",
  "contest-current-volume": "Volume Transaksi Saat Ini",
  "contest-date-range": "{date} {month} , pukul {time} {utc}",
  "contest-dialog-btn-text": "Konfirmasi",
  "contest-difference-to-foward": "Kurang {num} [unit] dari trader top berikutnya",
  "contest-earn-rewards": "Hadiah yang Didapatkan ({unit})",
  "contest-ended": "Acara Berakhir",
  "contest-find-more-premium-assets": "Perdagangkan lebih banyak koin di platform Spot!",
  "contest-latest-update": "Data akan diperbarui pada pukul {time}{utc}.",
  "contest-less": "Lebih Sedikit",
  "contest-limit-desc": "Agar dapat memenuhi syarat untuk mendapatkan hadiah, Anda harus memenuhi volume perdagangan Spot minimum senilai {amount} {unit}.",
  "contest-list-show-more": "Lihat Selengkapnya",
  "contest-login": "Masuk",
  "contest-month": "Januari,Februari, Maret,April,Mei,Juni,Juli,Agustus,September,Oktober,November,Desember",
  "contest-my-rank": "Peringkat Saya",
  "contest-no-rank": "Peringkat tidak tersedia. Ikuti terus!",
  "contest-no-rank-yet": "Belum Ada Peringkat",
  "contest-not-registered": "Anda tidak mendaftar untuk kontes perdagangan ini",
  "contest-num-of-participants": "Jumlah Peserta",
  "contest-popup-success": "Trade Sekarang!",
  "contest-ranking": "Peringkat",
  "contest-register": "Daftar Sekarang",
  "contest-registered": "Terdaftar",
  "contest-registration-ends": "Pendaftaran Berakhir",
  "contest-rewards-earned": "Hadiah yang Didapatkan ({unit})",
  "contest-share": "Bagikan",
  "contest-symbol-scope": "Pasangan Spot",
  "contest-terms-conditions": "<p>Syarat & Ketentuan</p>",
  "contest-to-spot-trade": "Acara telah dimulai. Trade dan deposit sekarang!",
  "contest-u-earned-king": "Anda memenangkan hadiah “Trader Supreme”",
  "contest-u-earned-sunny": "Anda memenangkan hadiah “Trader Top”",
  "contest-unqualified": "Ups, Anda tidak memenuhi syarat untuk mengikuti acara ini. Jika memiliki pertanyaan, silakan menghubungi layanan dukungan pelanggan kami.",
  "contest-updated-daily-at": "*Terakhir diperbarui pada pukul {time} （UTC0）.",
  "contest-will-start-tips": "Pendaftaran berhasil! Acara akan dimulai pada pukul{time}. Ikuti terus!",
  "contest-your-rewards": "Hadiah Anda yang memenuhi syarat",
  "contract_account": "Akun Derivatif",
  "createErrorCode400": "Data yang dikirim oleh pengguna mengandung parameter ilegal. Harap memeriksa pesan dan perincian kesalahan untuk mendapatkan informasi selengkapnya.",
  "createErrorCode401": "Saldo tidak mencukupi.",
  "createErrorCode402": "Jumlah bot yang dibuat oleh pengguna telah mencapai batas.",
  "createErrorCode403": "TERLARANG",
  "createErrorCode404": "Sumber daya yang diminta tidak ditemukan.",
  "createErrorCode407": "Jenis pengguna ini tidak mendukung pembuatan Akun Sekunder Bot Grid.",
  "createErrorCode408": "Target duplikasi investasi reguler telah dipilih",
  "createErrorCode409": "Jumlah investasi maksimum tidak valid",
  "createErrorCode410": "Jumlah investasi maksimum tidak valid",
  "createErrorCode411": "Bot telah ditutup",
  "createErrorCode412": "Akun Margin Terpadu sedang ditingkatkan",
  "createErrorCode500": "Kesalahan Server Internal",
  "createErrorCode501": "Batas Waktu Pemrosesan Internal",
  "createErrorCode503": "Saat ini Bot DCA tidak dapat ditutup dan mungkin sedang berproses untuk melakukan transaksi beli",
  "currency": "Koin",
  "dailyRate": "Suku Bunga Harian",
  "deposit": "Setor",
  "detail": "Detail",
  "direction": "Arah",
  "end": "Waktu Berakhir",
  "fiat": "Fiat",
  "filled": "Terisi",
  "filter": "Filter",
  "from": "Waktu Mulai",
  "global_setting_quick_order_desc": "<p>1.Pesanan Pasar (Penempatan Pesanan Cepat)</p>\n<p>2.Harap diperhatikan bahwa kuantitas beli terpenuhi Anda mungkin akan sedikit berbeda dari kuantitas pesanan yang Anda masukkan.</p>",
  "global_setting_quick_order_label": "Pembuatan Pesanan Cepat",
  "global_setting_title": "Pengaturan Kustom (Terapkan ke Spot)",
  "hint": "Pengingat",
  "innovateQuota": "Kuota Tersedia",
  "kline": "Grafik",
  "l_version_tip": "Harap unduh versi terbaru Bybit untuk mengikuti acara Bybit Launchpad.",
  "LastTradedPrice": "Harga",
  "leverage": "Leverage",
  "leverage_can_borrow": "Dapat Dipinjam",
  "leverage_can_deposit": "Margin",
  "leverage_data": "Data Margin",
  "leverage_forced_order": "Pesanan Likuidasi",
  "leverage_go_trade": "Berdagang Sekarang",
  "leverage_loan_limit": "Jumlah Pinjaman Maksimum",
  "leverage_min_borrow": "Jumlah Pinjaman Minimum",
  "leverage_off_trade_tip": "Mohon mengaktifkan leverage untuk trading dengan leverage.",
  "leverage_yearly_rate": "Suku Bunga Tahunan",
  "leverageCloseErrInfo": "Gagal! Silakan menyelesaikan semua pembayaran sebelum mematikan Perdagangan Margin.",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leverageLoanTips": "Aksi ini tidak dapat diselesaikan karena tingkat penggunaan IM/MM Akun Margin Terpadu Anda telah melampaui ambang batas.",
  "leverageLP_banner_title": "Perdagangan Margin Spot Bybit",
  "leverageLP-banner-desc": "Tingkatkan imbal hasil dengan berinvestasi menggunakan dana pinjaman",
  "leverageLP-faq-a1": "Untuk melihat daftar yang lengkap, silakan merujuk ke <a href=\"{url}\" target=\"_blank\" > daftar aset pinjaman dan jaminan (Perdagangan Margin).</a>",
  "leverageLP-faq-a10": "Klik Pesanan → Pesanan Spot → Riwayat Pelunasan → Leveling yang Kuat untuk melihat catatan transaksi.",
  "leverageLP-faq-a11": "Klik Pesanan→ Pesanan Spot→ Riwayat Pelunasan untuk melihat riwayat pinjaman dan pelunasan Anda.",
  "leverageLP-faq-a2": "Perdagangan Margin di Bybit membebankan biaya perdagangan Spot, bunga, dan biaya penutupan posisi. Silakan merujuk ke <a href=\"{url}\" target=\"_blank\" >Perdagangan Spot Margin Bybit: Komisi & Ikhtisar untuk melihat rincian biaya selengkapnya.</a>",
  "leverageLP-faq-a3": "Perdagangan Margin mengharuskan Anda untuk menjaminkan aset kripto guna meminjam leverage di akun Spot Bybit.",
  "leverageLP-faq-a4": "Tidak. Anda tidak lagi memenuhi syarat untuk terlibat dalam perdagangan leverage apabila masih memiliki Pinjaman Institusional yang aktif. Jika Anda memerlukan UID agar dihapus dari daftar pengguna Pinjaman Institusional, harap mengirimkan surel ke institutional_services{'@'}bybit.com untuk melanjutkan Perdagangan Margin Bybit.",
  "leverageLP-faq-a5": "Suku bunga pinjaman jumlahnya bervariasi, tergantung pada level VIP Anda. Silakan merujuk ke <a href=\"{url}\" target=\"_blank\"> data leverage untuk mendapatkan detail selengkapnya.</a>",
  "leverageLP-faq-a6": "Bunga akan dihitung setiap jam. Perlu digaris bawahi, penambahan waktu kurang dari satu jam juga akan dihitung setiap jam.",
  "leverageLP-faq-a7": "Anda akan menerima dua (2) notifikasi risiko melalui SMS dan surel:\n\n(1) Peringatan risiko akan dipicu saat tingkat risiko akun Spot Anda ≥ 87%. Anda akan menerima notifikasi SMS dan surel sebagai pengingat untuk menambahkan jaminan (mentransfer lebih banyak aset jaminan) guna menghindari penutupan paksa pada posisi Anda.\n\n(2) Saat tingkat risiko akun Spot ≥ 95%, you'll Anda akan menerima peringatan likuidasi paksa wajib melalui SMS dan surel, untuk memberi tahu bahwa posisi Anda telah dilikuidasi.\n\nSilakan merujuk ke <a href=\"{url}\" target=\"_blank\"> Risiko dan Likuidasi Paksa (Perdagangan Leverage Spot) untuk mendapatkan detail selengkapnya tentang proses dan kriteria yang berkaitan dengan al ini.</a>",
  "leverageLP-faq-a8": "Dana Asuransi Margin (MAF) menutup kerugian posisi trader setelah likuidasi paksa atas posisi dilakukan, akibat tidak cukupnya jumlah dana di akun untuk melunasi pinjaman.\n\nJika akun Spot Anda mengalami kebangkrutan, platform akan menggunakan MAF untuk melunasi utang Anda. Oleh karena itu, biaya likuidasi akan dibebankan untuk menutup biaya MAF.",
  "leverageLP-faq-a9": "Jika masih ada pinjaman dana outstanding setelah margin digunakan untuk melunasi pinjaman, maka sisa kerugian akan diasuransikan oleh Dana Asuransi Margin.",
  "leverageLP-faq-q1": "Mata uang kripto apa saja yang dapat digunakan sebagai aset pinjaman atau jaminan dalam perdagangan margin?",
  "leverageLP-faq-q10": "Di mana saya dapat mengakses catatan leveling yang kuat?",
  "leverageLP-faq-q11": "Di mana saya dapat mengakses riwayat pinjaman dan pelunasan?",
  "leverageLP-faq-q2": "Apakah ada biaya komisi yang dibebankan untuk Perdagangan Margin Bybit?",
  "leverageLP-faq-q3": "Akun Bybit mana yang harus saya gunakan saat memperdagangkan margin?",
  "leverageLP-faq-q4": "Jika saya telah mengaktifkan Pinjaman Institusional, apakah saya masih bisa berdagang dengan margin atau leverage?",
  "leverageLP-faq-q5": "Berapa suku bunga pinjaman untuk Perdagangan Margin Bybit?",
  "leverageLP-faq-q6": "Berapa lama waktu yang dibutuhkan bagi bunga untuk mulai terakumulasi?",
  "leverageLP-faq-q7": "Dalam situasi apa saya akan menerima notifikasi risiko untuk Perdagangan Margin?",
  "leverageLP-faq-q8": "Apa itu Dana Asuransi Margin?",
  "leverageLP-faq-q9": "Apa yang terjadi jika dana di akun Spot saya tidak mencukupi apabila terjadi likuidasi paksa?",
  "leverageLP-faq-title": "T&J",
  "leverageLP-feature-title": "Mengapa Memilih Perdagangan Margin?",
  "leverageLP-feature1": "Meningkatkan Pendapatan Perdagangan",
  "leverageLP-feature2": "Dukungan Perdagangan Posisi Long/Short",
  "leverageLP-feature3": "Pemanfaatan Modal yang Lebih Optimal",
  "leverageLP-feature4": "Diversifikasi Aset",
  "leverageLP-whats-leverage": "Apa Itu Perdagangan Margin Spot?",
  "leverageLP-whats-leverage-c": "Perdagangan Margin Spot Bybit adalah produk derivatif dari perdagangan Spot, yang memungkinkan trader untuk meminjam dan menerapkan leverage atas dana dengan menjaminkan aset kripto mereka. Singkatnya, dana pinjaman akan digunakan untuk meningkatkan laba perdagangan pada posisi leverage di pasar yang bervolatilitas rendah atau tinggi.",
  "leverageTest": "Kuis Perdagangan Margin",
  "leverageTestSubTitle": "Anda harus menjawab seluruh pertanyaan dengan benar untuk memulai Perdagangan Margin.",
  "leverageTryAgain": "Sistem bermasalah. Silakan mencoba lagi nanti.",
  "liquidate": "Likuidasi",
  "liquidationErrorInfo": "Gagal! Likuidasi telah terpicu di akun Anda.",
  "load_more": "Muat Lebih Banyak",
  "loan": "Meminjam",
  "loan_limit": "Jangka Waktu Pinjaman",
  "loan_spot_account": "Akun Spot",
  "loanLualityDeposit1": "Anda hanya dapat mengurangi jumlah jaminan saat rasio LTV saat ini lebih rendah daripada LTV Awal. ",
  "loanLualityDeposit2": "Penurunan jaminan maksimum adalah jumlah yang diperlukan untuk mengembalikan rasio LTV ke level awalnya.",
  "loanLualityDeposit3": "Jumlah jaminan tidak dapat dikurangi jika nilai pengurangan lebih rendah daripada margin yang dapat disesuaikan.",
  "loanTime": "Cap Waktu",
  "login": "Masuk",
  "lp_go_home": "Kembali",
  "lpn_one_progress_info": "Hasilnya diharapkan akan tersedia pada",
  "lpn_order_btn": "Langganan Saya",
  "lpn_order_btn_cancel": "Batalkan",
  "lpn_order_btn_confirm": "Konfirmasi",
  "lpn_order_submit_error": "Gagal!",
  "lpn_order_submit_error_desc": "Kesalahan sistem. Silakan mencoba lagi nanti.",
  "lpn_unfold": "Selengkapnya",
  "lt_all": "Semua",
  "lt_amount": "Jumlah",
  "lt_amount_not_enough": "Saldo {currency} yang tersedia tidak mencukupi!",
  "lt_entry_tips": "{symbol} ({direction}) mendukung Perdagangan Token Leverage. Berdagang sekarang!",
  "lt_freerate": "Tarif Biaya",
  "lt_lowcase_redemption": "penukaran",
  "lt_lowcase_subscription": "berlangganan",
  "lt_open_success_txt": "Selamat, Anda berhasil mengaktifkan Token Leverage!",
  "lt_orders_submitted": "Pesanan {ordertype} Anda untuk {quantity} berhasil diajukan.",
  "lt_redemption": "Penjualan",
  "lt_redemption_failed_change_position": "Penyeimbangan kembali untuk pasangan pilihan telah diaktifkan dan saat ini penjualan tidak didukung. Silakan coba Lagi.",
  "lt_redemption_failed_closed": "Saat ini penjualan untuk aset pilihan tidak didukung. Silakan coba Lagi.",
  "lt_redemption_failed_input_quantity": "Silakan memasukkan jumlah penjualan",
  "lt_redemption_failed_net_worth": "Nilai aset bersih tidak valid dan saat ini penjualan tidak didukung. Silakan coba Lagi.",
  "lt_redemption_failed_wear_position": "Rekening Anda sedang dilikuidasi dan saat ini penjualan tidak didukung. Silakan coba Lagi.",
  "lt_redemption_max_quanlity": "Jumlah penjualan maksimal per transaksi untuk aset pilihan tidak bisa melebihi {quantity}.",
  "lt_redemption_min_quanlity": "Jumlah penjualan minimal per transaksi untuk aset pilihan tidak bisa kurang dari {quantity}.",
  "lt_redemption_tips": "Jumlah aktual penjualan mungkin akan sedikit berbeda.",
  "lt_subscription": "Pembelian",
  "lt_subscription_failed_change_position": "Penyeimbangan kembali untuk beberapa pasangan telah diaktifkan dan saat ini pembelian tidak didukung. Silakan coba Lagi.",
  "lt_subscription_failed_close_position": "Rekening Anda sedang dilikuidasi dan saat ini pembelian tidak didukung. Silakan coba Lagi.",
  "lt_subscription_failed_closed": "Saat ini, pembelian untuk aset pilihan tidak didukung. Silakan coba Lagi.",
  "lt_subscription_failed_input_amount": "Silakan memasukkan jumlah pembelian",
  "lt_subscription_failed_invalid_value": "Nilai aset bersih tidak valid dan saat ini pembelian tidak didukung. Silakan coba Lagi.",
  "lt_subscription_failed_large_amount": "Jumlah pembelian Anda terlalu besar dan tingkat risiko Anda akan meningkat. Kemungkinan, akan ada risiko likuidasi.",
  "lt_subscription_failed_wear_position": "Rekening Anda memiliki ekuitas negatif dan saat ini pembelian tidak didukung. Silakan coba Lagi.",
  "lt_subscription_max_amount": "Jumlah pembelian maksimal per transaksi untuk aset pilihan tidak bisa melebihi {amount}.",
  "lt_subscription_min_amount": "Jumlah pembelian minimal per transaksi untuk aset pilihan tidak bisa kurang dari {amount}.",
  "lt_subscription_redemption": "Pembelian & Penjualan",
  "lt_subscription_redemption_records": "Riwayat Pembelian & Penjualan",
  "lt_subscription_tips": "Jumlah aktual pembelian mungkin akan sedikit berbeda.",
  "lt_subscription_usdt_not_enough": "Saldo USDT yang tersedia tidak mencukupi. Harap melakukan deposit atau mentransfer dana terlebih dahulu.",
  "lt-landing-banner-desc": "Leverage Tanpa Risiko Likuidasi",
  "lt-landing-banner-title": "Token Leverage Bybit",
  "lt-landing-faq-a1": "NAV, atau nilai aset bersih, mengacu kepada nilai yang dimiliki oleh Token Leverage. NAV Token Leverage bergerak sejalan dengan fluktuasi harga di pasar Kontrak Perpetual.",
  "lt-landing-faq-a2": "Mari menggunakan BTC sebagai contoh: \n\nBTC3L mengacu kepada Token Leverage yang memegang posisi long pada Kontrak BTCUSDT Perpetual dengan leverage 3x.\n\nBTC3S mengacu kepada Token Leverage yang memegang posisi short pada Kontrak BTCUSDT Perpetual dengan leverage 3x.",
  "lt-landing-faq-a3": "Perdagangan Token Leverage akan disalurkan secara langsung melalui Akun Spot Bybit Anda.",
  "lt-landing-faq-a4": "Harap merujuk ke <a href=\"{url}\" target=\"_blank\" >Perbedaan Token Leverage dan Perdagangan Derivatif</a>.",
  "lt-landing-faq-a5": "Harap merujuk ke <a href=\"{url}\" target=\"_blank\" >Token Leverage Bybit: Penjelasan Biaya </a>.",
  "lt-landing-faq-a6": "Tidak ada risiko likuidasi. \n\nMari menggunakan BTC3L sebagai contoh. Rentang target leverage adalah [2,4]. Mekanisme penyeimbangan kembali akan secara otomatis terpicu ketika rasio leverage aktual ≥ 4x atau ≤ 2x, akan disesuaikan agar mencapai target leverage 3x.\n\nCatatan: Harap diperhatikan bahwa nilai aset bersih Token Leverage dapat turun ke nol dan tidak akan bisa dipulihkan.",
  "lt-landing-faq-a7": "Penyeimbangan kembali adalah proses yang dilakukan untuk memastikan posisi Kontrak Perpetual aset dasar terus-menerus disesuaikan agar mencapai target leverage. Mekanisme penyeimbangan kembali akan secara otomatis terpicu ketika rasio leverage aktual berada di luar rentang target leverage. \n\nUntuk mengetahui informasi selengkapnya, harap merujuk ke <a href=\"{url}\" target=\"_blank\"> Mekanisme Penyeimbangan Kembali Token Leverage Bybit</a>.",
  "lt-landing-faq-a8": "Saat ini, fitur penarikan tidak didukung.",
  "lt-landing-faq-q1": "Apa yang dimaksud dengan nilai aset bersih (NAV)?",
  "lt-landing-faq-q2": "Apa yang dilambangkan oleh simbol dalam Token Leverage?",
  "lt-landing-faq-q3": "Akun apa yang dapat saya gunakan untuk memperdagangkan Token Leverage di Bybit?",
  "lt-landing-faq-q4": "Apa perbedaan Token Leverage dan perdagangan Derivatif di Bybit?",
  "lt-landing-faq-q5": "Apa saja biaya yang berkenaan dengan Token Leverage?",
  "lt-landing-faq-q6": "Dalam situasi apa posisi Token Leverage saya dilikuidasi?",
  "lt-landing-faq-q7": "Apa yang dimaksud dengan mekanisme penyeimbangan kembali?",
  "lt-landing-faq-q8": "Bisakah Token Leverage ditarik?",
  "lt-landing-faq-title": "T&J",
  "lt-landing-feature-title": "Keuntungan Token Leverage",
  "lt-landing-feature1": "Eksposur leverage yang berpotensi meningkatkan profitabilitas",
  "lt-landing-feature2": "Tanpa risiko likuidasi",
  "lt-landing-feature3": "Pemanfaatan modal yang tinggi",
  "lt-landing-feature4": "Berdagang dengan aman dan mudah",
  "lt-landing-learn-more": "Pelajari",
  "lt-landing-operation": "Tindakan",
  "lt-landing-symbol": "Pasangan Perdagangan",
  "lt-landing-whats-lt": "Apa yang dimaksud dengan Token Leverage?",
  "lt-landing-whats-lt-c": "Token Leverage adalah produk derivatif yang memberikan eksposur leverage ke aset dasar tanpa adanya persyaratan margin, yang berpotensi meningkatkan profitabilitas dan tidak memiliki risiko likuidasi. \n\nMasing-masing Token Leverage merepresentasikan sekeranjang posisi Kontrak Perpetual. \n\nNilai aset bersih (net asset value/NAV) dari Token Leverage bergerak sejalan dengan fluktuasi harga di pasar Kontrak Perpetual.",
  "lt-learning-video-title": "Video pembelajaran untuk pengguna leverage token pemula",
  "ltLearningVideo": "Video tutorial",
  "ltNav": "Nilai Aset Net",
  "ltOpenRiskContent": "Token Leverage mampu memberikan eksposur leverage ke aset dasar.\n\nBybit berhak untuk mengubah Ketentuan Layanan dan melakukan langkah-langkah berikut berdasarkan kondisi pasar tanpa memberi tahu pengguna sebelumnya:\n\n1. Menghapus Token Leverage apa pun.\n\n2. Menambah atau menyesuaikan batasan, seperti batas jumlah posisi. Jika perubahan semacam itu terjadi dan diinformasikan kepada pengguna, harap mengunjungi Blog kami untuk mengetahui informasi selengkapnya.                                                                                                                                                                                       Terkait batas jumlah posisi, jumlah aktual yang dapat Anda akses mungkin akan berbeda dari jumlah yang dinyatakan secara resmi karena adanya masalah teknis. Harap memperhatikan risiko yang menyertainya. \n\n3. Menyesuaikan posisi aset dasar secara dinamis untuk mencapai target leverage. \n\n4. Menghapus ketentuan apa pun dalam Ketentuan Layanan.\n\nHarap memastikan bahwa Anda telah sepenuhnya memahami Token Leverage sebagai produk keuangan dan berinvestasi secara rasional berdasarkan toleransi risiko serta tingkat keahlian Anda. Bybit tidak bertanggung jawab terhadap segala bentuk risiko dan kerugian yang berhubungan dengan perdagangan Token Leverage. \n\nDengan melanjutkan, Anda juga menyetujui <a href={url} target=\"_blank\">Ketentuan Layanan</a> perdagangan Token Leverage.",
  "ltOpenRiskSubmit": "Mengerti & Mengaktifkan Token Leverage",
  "ltOpenRiskTitle": "Perjanjian Layanan Token Leverage",
  "ltTestDialogContent": "Anda yakin ingin keluar dari kuis? Jawaban Anda tidak akan disimpan.",
  "ltTestDialogContinue": "Tidak",
  "ltTestDialogExit": "Ya",
  "ltTestDialogTitle": "Konfirmasi",
  "ltTestDone": "Anda telah menjawab <span>{num}/{numAll}</span> pertanyaan",
  "ltTestDoneFail": "Ups, Anda hanya menjawab {num}/{numAll} pertanyaan dengan benar! Silakan ikuti kuis lagi.",
  "ltTestPassContent": "Selamat, Anda berhasil menyelesaikan kuis!",
  "ltTestPassRead": "Baca selanjutnya",
  "ltTestPassReject": "Lewati Sekarang",
  "ltTestResubmit": "Silakan Coba Lagi",
  "ltTestSubmit": "Kirim Sekarang",
  "ltTestSubTitle": "Anda harus menjawab semua pertanyaan dengan benar untuk memulai perdagangan Token Leverage.",
  "ltTestTitle": "Kuis",
  "ltUnderlying": "Underlying",
  "margin_coin": "Koin",
  "margin_discount": "Pengali",
  "margin_discount_eg": "Contoh:",
  "margin_discount_eg_body": "Semisal Trader A memiliki 1 BTC, 1000 BIT, dan 100 TRX di Akun Spotnya.\nDengan asumsi harga pasar BTC, BIT, dan TRX masing-masing adalah 50.000 USDT, 5 USDT, dan 0,50 USDT, total nilai jaminan untuk Perdagangan Margin adalah: \n(1 (Kuantitas) * 50000 (Harga) * 1 (Pengali) * 1 ) + (1.000 (Kuantitas) * 5 (Harga) * 0,9 (Pengali) + (100 (Kuantitas) * 0,5 (Harga) * 0 (Pengali) = 54.500 USDT.",
  "margin_discount_rate": "Spesifikasi Margin",
  "margin_lq_order": "Pesanan likuidasi",
  "MARKET": "Harga Pasar",
  "max": "Maksimum",
  "more": "Selengkapnya",
  "network_error": "Permintaan gagal. Silakan coba lagi nanti.",
  "NEW": "Aktif",
  "nextPage": "Halaman Berikutnya",
  "nodata": "Tidak Ada Catatan",
  "none": "Tidak ada",
  "noRecordFound": "Tidak ditemukan catatan",
  "og_description": "Beli, jual & trade {symbol} dengan aman di bursa spot Bybit. Trade dengan percaya diri & nikmati trading berbiaya rendah dan likuiditas yang dalam.",
  "og_title": "{symbol} {'|'} Fee Rendah Saat Beli, Jual & Trade {'|'} Spot Bybit",
  "ol_agree": "Saya telah membaca dan menyetujui",
  "ol_agrmt": "Perjanjian Peminjaman Aset Digital",
  "ol_agrmt_2": "<Perjanjian Peminjaman Aset Digital>",
  "ol_agrmt_err": "Perjanjian Peminjaman Aset Digital harus ditandatangani.",
  "ol_amt": "Jumlah Pinjaman",
  "ol_amt_err": "{condition} Jumlah pinjaman adalah {amount} {unit}",
  "ol_amt_tip": "Masukkan jumlah pinjaman",
  "ol_app_sub": "Permohonan Peminjaman Diajukan",
  "ol_app_time": "Waktu Permohonan",
  "ol_apply_title": "Permohonan Online untuk Peminjaman Institusional",
  "ol_cancel": "Apakah Anda yakin ingin keluar dari permohonan ini?",
  "ol_cfm_product": "Produk Peminjaman Institusional",
  "ol_check_app": "Cek permohonan Anda",
  "ol_coin": "Koin",
  "ol_col_amt": "Jumlah",
  "ol_col_app_tm": "Waktu Permohonan",
  "ol_col_dl": "Jangka Waktu Peminjaman",
  "ol_col_no": "Nomor Pesanan",
  "ol_col_pn": "Nama Produk",
  "ol_col_sub": "Akun Sekunder",
  "ol_confirm": "Konfirmasi Permohonan Peminjaman",
  "ol_contact_desc": "Pastikan seluruh informasi baru dan valid karena seluruh peringatan risiko akan dikirim ke alamat surel serta nomor ponsel Anda.",
  "ol_contact_tip": "Mohon menghubungi tim Pengembangan Bisnis kami",
  "ol_contact_title": "Detail Kontak",
  "ol_detail_title": "Detail Permohonan Peminjaman",
  "ol_eg": "Contoh",
  "ol_email": "Alamat Surel",
  "ol_email_err_invalid": "Alamat surel tidak valid",
  "ol_email_tip": "Masukkan alamat surel Anda",
  "ol_max": "maximum",
  "ol_mgr": "ID Manajer Pengembangan Bisnis Anda",
  "ol_mgr_err_invalid": "ID Tidak Valid",
  "ol_mgr_link": "Klik untuk mendapatkan ID Manajer Pengembangan Bisnis Anda",
  "ol_mgr_tip": "Masukkan ID Manajer Pengembangan Bisnis Anda",
  "ol_min": "minimum",
  "ol_mine_title": "Permohonan Peminjaman Saya",
  "ol_month": "{month} Bulan",
  "ol_no_code_rcd": "Kode negara tidak ditemukan",
  "ol_notice_desc": "<li>Peminjaman Institusional hanya tersedia untuk trader institusional.</li>\n<li>Trader institusional yang mengajukan permohonan peminjaman harus memiliki aset senilai minimal 500.000 USDT.</li>\n<li>Pinjaman dapat digunakan di pasar Spot atau Derivatif, tergantung jenis produk yang dipilih.</li>",
  "ol_notice_desc_lmt": "<li>Jumlah pinjaman minimum adalah 1.000.000 USDT, sementara jumlah pinjaman maksimum adalah 20.000.000 USDT.</li>",
  "ol_notice_title": "Instruksi Peminjaman Institusional",
  "ol_phone": "Nomor Ponsel",
  "ol_phone_err": "Pilih kode area yang tepat dan masukkan nomor ponsel Anda",
  "ol_phone_err_invalid": "Nomor ponsel tidak valid",
  "ol_phone_tip": "Masukkan nomor ponsel Anda",
  "ol_prd": "Silakan memilih produk Peminjaman Institusional",
  "ol_prd_3x_spot": "Pinjaman Institusional: 3x Leverage (Spot)",
  "ol_prd_3x_spot_futures": "Pinjaman Institusional: 3x Leverage (Spot dan Derivatif)",
  "ol_prd_5x_spot": "Pinjaman Institusional: 5x Leverage (Spot)",
  "ol_prd_link": "Pelajari selengkapnya mengenai produk tersebut",
  "ol_prd_tip": "Jika Anda mengubah aset dalam Akun Spot menjadi aset nonmargin, risiko likuidasi akan meningkat. Klik <a href={url} target=\"_blank\">di sini</a> untuk mengetahui informasi lebih lengkap mengenai aset margin yang didukung di pasar Spot Bybit.",
  "ol_recent_year_only": "Hasil pencarian, termasuk permohonan peminjaman di tahun terakhir saja.",
  "ol_status": "Status Peminjaman",
  "ol_status_list": "Semua,Ditinjau,Permohonan Diterima,Ditolak,Dicairkan",
  "ol_subacc": "Tambahkan Akun Sekunder",
  "ol_subacc_tip": "Masukkan UID Akun Sekunder yang ingin Anda tambahkan. Jika perlu menambahkan beberapa Akun Sekunder, silakan menghubungi tim Pengembangan Bisnis kami.",
  "ol_term": "Jangka Waktu Peminjaman",
  "ol_term_err": "Silakan memilih jangka waktu permohonan peminjaman Anda.",
  "ol_unit_month": "Unit: Bulan",
  "ol_view_agrmt": "Lihat Lampiran Perjanjian",
  "operationSuccess": "Berhasil",
  "or": "atau",
  "orderBook": "Buku Order",
  "orderHistory": "Riwayat Order",
  "orderId": "ID Pesanan",
  "orderSuccessful": "Order berhasil dikirim",
  "orderType": "Jenis Pesanan",
  "otcErrorInfo": "Ups, Anda telah mengaktifkan Pinjaman Institusional dan tidak berhak lagi untuk menggunakan Perdagangan Margin.",
  "outstanding": "Pinjaman",
  "pa_accumated_profit_descript": "Laba Kumulatif adalah jumlah laba yang dihasilkan setiap hari selama periode tertentu. Grafik hanya menampilkan data per hari sebelumnya.",
  "pa_accumated_profit_select": "Laba Kumulatif Aktual",
  "pa_accumated_profit_title": "Laba Kumulatif",
  "pa_accumulated_account": "ROI Kumulatif dari Akun Spot",
  "pa_accumulated_btc": "Perubahan harga kumulatif BTC (%)",
  "pa_accumulated_btc_select": "Perubahan harga Kumulatif aktual BTC (%)",
  "pa_accumulated_pnl": "L&R 7 Hari",
  "pa_accumulated_pnl_select": "ROI Kumulatif Aktual",
  "pa_accumulated_roi_descript": "ROI kumulatif mengevaluasi efisiensi laba yang dihasilkan dalam investasi selama periode tertentu. Grafik hanya menampilkan data per hari sebelumnya.",
  "pa_accumulated_roi_title": "ROI Kumulatif",
  "pa_assets_distribution_descript": "Distribusi Aset adalah bobot relatif setiap aset di Akun Spot terhadap total nilai semua aset dalam USDT.",
  "pa_assets_distribution_title": "Distribusi Aset",
  "pa_daily_pnl": "L&R Hari Ini",
  "pa_daily_profit_descript": "Grafik L&R harian hanya menampilkan data per hari sebelumnya.",
  "pa_daily_profit_select": "L&R hari ini",
  "pa_daily_profit_title": "L&R Harian",
  "pa_last_30_day": "30 Hari Terakhir",
  "pa_last_7_day": "7 Hari Terakhir",
  "pa_last_90_day": "90 Hari Terakhir",
  "pa_others": "Lainnya",
  "pa_page_description": "Dapatkan informasi terkini tentang kinerja portofolio Spot Anda dan sesuaikan strategi investasi dengan perubahan pasar waktu nyata.",
  "pa_page_title": "Analisis L&R Aset Spot",
  "pa_quantity": "Kuantitas {Coin}",
  "pa_spot_pnl_descript": "1. Data L&R Spot akan diperbarui setiap hari pada pukul 07.00 WIB.\n2. Data L&R Spot terbaru akan dihitung antara pukul 07.00 WIB hingga 13.00 WIB dan akan ditampilkan setiap hari setelah pukul 13.00 WIB.",
  "pa_spot_pnl_title": "Analisis L&R Spot",
  "pa_total_assets": "Total Aset",
  "pa_total_assets_value_descript": "Total Nilai Aset mengacu pada total nilai semua aset di Akun Spot (termasuk aset yang dipinjam), dan akan dipengaruhi oleh penarikan, transfer (masuk dan keluar), pinjaman, dan posisi margin.",
  "pa_total_assets_value_select": "Nilai Aset",
  "pa_total_assets_value_title": "Total Nilai Aset",
  "pa_update_on": "Terakhir Diperbarui:",
  "pa_value": "Nilai {Coin}",
  "pa_weightage": "Bobot {Coin}",
  "pauseTradeTip": "Saat ini, {symbol} tidak tersedia untuk perdagangan. Untuk mengetahui informasi selengkapnya, silakan mengunjungi <a href={url} target=\"_blank\">blog</a> kami.",
  "placeHolder": "Pilih",
  "prevPage": "Halaman Sebelumnya",
  "price": "Harga",
  "quantity": "Jlh.",
  "ReduceLoan": "Kurangi",
  "ReduceLoanAssets": "Kurangi Jumlah Jaminan",
  "ReduceLoanTip1": "Jumlah jaminan tidak dapat dikurangi, kecuali jika rasio LTV saat ini lebih rendah daripada LTV Awal.  ",
  "ReduceLoanTip2": "Jumlah jaminan tidak dapat dikurangi, kecuali jika nilai pengurangan lebih rendah daripada margin yang dapat disesuaikan.",
  "ReduceLoanTip3": "Jumlah jaminan tidak dapat dikurangi jika rasio LTV saat ini setara dengan atau melebihi rasio LTV awal. Harap mencoba lagi. ",
  "ReduceLoanTip4": "Jumlah jaminan dapat dikelola di laman Pesanan. Anda dapat menambah jaminan kapan saja, tetapi hanya bisa menurunkannya ketika rasio LTV saat ini lebih rendah daripada LTV Awal. ",
  "repayment": "Membayar Kewajiban",
  "reset": "Reset",
  "reverse_contract_account": "Akun Derivatif Inverse",
  "riskWarning": "Konfirmasi Risiko",
  "search": "Cari",
  "side": "Arah",
  "signup": "Daftar",
  "spot_account": "Akun Spot",
  "status": "Status",
  "stop_limit": "TP/SL",
  "stop_limit_tips_2": "Perdagangan Margin tidak dapat diaktifkan jika Anda memiliki pesanan Ambil Untung atau Stop Rugi.",
  "success": "Berhasil",
  "sure": "sure",
  "tests1": "",
  "times": "kali",
  "timestamp": "Cap Waktu",
  "title_404": "404 {'|'} Perdagangan Spot Bybit  ",
  "to": "hingga",
  "toastTheSymbolNotExist": "Ups, pasangan Spot yang Anda pilih tidak tersedia untuk diperdagangkan.",
  "total": "Total",
  "tradeChange": "Perubahan %",
  "tradeId": "ID Transaksi",
  "transfer": "Transfer",
  "usdc_contract_account": "Akun Derivatif USDC",
  "VIP99": "Supreme VIP",
  "volume": "Jumlah yang Terpenuhi",
  "vote_btn_trade": "Trade"
}